import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    ProductType,
} from 'app/enums/label.enums'

import {
    PreBookingsTableType,
} from '../../../PreBooking/PreBooking.types'

const config: SkyNetTableConfig<keyof PreBookingsTableType> = {
    name: 'Pooling.PreBookings',
    tabs: [{
        name: 'Pre Bookings',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'preBookingNumber',
                labelKey: 'Prebooking.number',
            },
            {
                name: 'originAirportIataCode',
                labelKey: 'OrderBaseTabView.from',
                filterField: 'originAirportIataCode',
                filterType: FilterType.Array,
            },
            {
                name: 'destinationAirportIataCode',
                labelKey: 'OrderBaseTabView.to',
                filterField: 'destinationAirportIataCode',
                filterType: FilterType.Array,
            },
            {
                name: 'pricingAccountCompanyName',
                labelKey: 'Prebooking.pricingAccount',
                filterField: 'pricingAccountCompanyName',
                filterType: FilterType.Array,
            },
            {
                name: 'customerExecution',
                labelKey: 'Prebooking.customerExecution',
                filterField: 'customerExecution',
                filterType: FilterType.Array,
            },
            {
                name: 'mawbNumber',
                labelKey: 'Prebooking.mawbNumber',
                filterField: 'mawbNumber',
                filterType: FilterType.Array,
            },
            {
                name: 'destinationCountryName',
                labelKey: 'Prebooking.destinationCountry',
            },
            {
                name: 'customerReference',
                labelKey: 'Prebooking.customerReference',
                filterField: 'customerReference',
                filterType: FilterType.Array,
            },
            {
                name: 'requestedHandover',
                labelKey: 'Prebooking.requestedHandover',
                filterField: 'requestedHandover',
                filterType: FilterType.Array,
                componentName: 'DateTimeCell',
            },
            {
                name: 'requestedHandoverWeek',
                labelKey: 'Prebooking.requestedHandoverWeek',
            },
            {
                name: 'requiredContainers',
                componentName: 'RequiredContainersList',
                allowedValuesEnum: ProductType,
                filterField: 'requiredContainersProductType',
                filterType: FilterType.Array,
                sorting: false,
                labelKey: 'Prebooking.requiredContainers',
            },
        ],
    }],
}

export default config
